import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

import { HttpHeadersService } from '../../core/shared-service/http-headers.service';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { IFacilityUserSummary } from '../../core/services/facility.model';

@Injectable({
  providedIn: 'root'
})
export class GetFacilityInfoByEmailService {

  rootScopeData: RootScopeDeclare;

  constructor(private httpClient: HttpClient, private rootScopeService: RootScopeService, private httpHeaderService: HttpHeadersService) {
    this.getRootScopeData();

  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

  getFacilityInformationByEmail(token: string): Observable<IFacilityUserSummary> {
   const headers = this.httpHeaderService.preLoginHttpAuthorizationHeader();
   const result = this.httpClient.get(environment.servicePath + '/facility_maintenance/byemail?token=' + token , {headers});
   return result as Observable<IFacilityUserSummary>;

  }
}
